export default "__VITE_ASSET__76de06e5__"